import { combineReducers } from "redux";

// etc
import auth from "modules/auth/reducer";
import ui from "modules/ui/reducer";

// master data
import masterdataMangement from "modules/master-data/reducers";
import productMangement from "modules/product-management/reducers"
import soMangement from "modules/sale-order/reducers"

export default combineReducers({
  auth,
  ui,
  ...masterdataMangement,
  ...productMangement,
  ...soMangement
});
